var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "licence-association-modal tw-p-5 leading-tight" },
    [
      _c(
        "swiper",
        {
          attrs: { allowTouchMove: false },
          on: {
            init: _vm.onInit,
            swiper: _vm.onSwiper,
            slideChangeTransitionEnd: _vm.onSlideChangeTransitionEnd,
            slideChangeTransitionStart: _vm.onSlideChangeTransitionStart,
          },
        },
        [
          _c(
            "swiper-slide",
            [
              _c("LoadingMini", { ref: "loading" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "messages",
                  staticStyle: { "margin-top": "0", position: "static" },
                },
                [
                  !!_vm.backendErrorMessages.length
                    ? _c("div", { staticClass: "message error show" }, [
                        _c("i", {
                          staticClass: "fa fa-times",
                          on: {
                            click: function ($event) {
                              return _vm.removeErrorsMessages()
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-exclamation-circle indicator",
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "message-inner" },
                          _vm._l(_vm.backendErrorMessages, function (message) {
                            return _c("div", {
                              domProps: { textContent: _vm._s(message) },
                            })
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-row row standard" }, [
                _c("label", { staticClass: "col-12" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("device.registrations.licence_number")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("input", {
                  staticClass: "form-input col-12 text-mono",
                  attrs: { type: "text", disabled: "" },
                  domProps: { value: _vm.formatLicenceId(_vm.props.dati.id) },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-row row standard" },
                [
                  _c("label", { staticClass: "col-12" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("device.registrations.phonenumber")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("FormInputPhone", {
                    attrs: {
                      name: "phoneNumber",
                      isInvalid:
                        _vm.phoneNumberShowError && _vm.phoneNumberIsInvalid,
                    },
                    on: { input: _vm.onPhoneInput, blur: _vm.blurPhoneInput },
                    model: {
                      value: _vm.phoneNumber,
                      callback: function ($$v) {
                        _vm.phoneNumber = $$v
                      },
                      expression: "phoneNumber",
                    },
                  }),
                  _vm._v(" "),
                  _vm.phoneNumberShowError && _vm.phoneNumberIsInvalid
                    ? _c("FormError", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "device.registrations.errors.invalidPhoneFormat"
                              )
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-row row standard" },
                [
                  _c("label", { staticClass: "col-12" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("device.registrations.association_type.email")
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email",
                      },
                    ],
                    staticClass: "form-input col-12",
                    attrs: { type: "email" },
                    domProps: { value: _vm.email },
                    on: {
                      blur: _vm.blurEmailInput,
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.emailShowError && _vm.emailIsInvalid
                    ? _c("FormError", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "device.registrations.errors.invalidEmailFormat"
                              )
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-row row standard" },
                [
                  _c("label", { staticClass: "col-12" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("device.registrations.datiName")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.datiName,
                        expression: "datiName",
                      },
                    ],
                    ref: "datiNameInput",
                    staticClass: "form-input col-12",
                    attrs: { type: "text" },
                    domProps: { value: _vm.datiName },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.datiName = $event.target.value
                        },
                        _vm.onDatiNameInput,
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _vm.datiNameIsInvalid
                    ? _c("FormError", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("device.registrations.errors.label_needed")
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-row row standard" },
                [
                  _c("label", { staticClass: "col-12" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("device.registrations.profile")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.datiProfile,
                          expression: "datiProfile",
                        },
                      ],
                      staticClass: "form-input col-12",
                      on: {
                        input: _vm.onProfilInput,
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.datiProfile = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v(
                          "-- " +
                            _vm._s(
                              _vm.$t(
                                "device.registrations.profileSelectPlaceholder"
                              )
                            ) +
                            " --"
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.props.profiles, function (profile) {
                        return _c(
                          "option",
                          {
                            key: profile.profileId,
                            domProps: { value: profile.profileId },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(profile.meta.name) +
                                "\n            " +
                                _vm._s(profile.meta.default ? "★" : null) +
                                "\n          "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.datiProfileIsInvalid
                    ? _c("FormError", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "device.registrations.errors.profile_needed"
                              )
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.useDvFlagAccess("beepiz-group-can:update"),
                      expression: "useDvFlagAccess('beepiz-group-can:update')",
                    },
                  ],
                  staticClass: "form-row row standard",
                },
                [
                  _c("label", { staticClass: "col-12" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("device.groupSelect")) +
                        " (" +
                        _vm._s(_vm.$t("global.optional")) +
                        ")\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.datiGroup,
                          expression: "datiGroup",
                        },
                      ],
                      staticClass: "form-input col-12",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.datiGroup = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        {
                          staticClass: "text-muted",
                          domProps: { value: null },
                        },
                        [
                          _vm._v(
                            "-- " + _vm._s(_vm.$t("device.noGroup")) + " --"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.props.groups, function (group) {
                        return _c(
                          "option",
                          { key: group.id, domProps: { value: group.id } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(group.name) +
                                "\n          "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.hasAnalytic
                ? _c("div", { staticClass: "form-row row standard" }, [
                    _c("label", { staticClass: "col-12" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("device.registrations.analyticCode")) +
                          " (" +
                          _vm._s(_vm.$t("global.optional")) +
                          ")\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.analyticCode,
                          expression: "analyticCode",
                        },
                      ],
                      ref: "analytic",
                      staticClass: "form-input col-12",
                      attrs: { type: "text", maxlength: "30" },
                      domProps: { value: _vm.analyticCode },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.analyticCode = $event.target.value
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex py-2" },
                [
                  _c(
                    "Btn",
                    {
                      staticClass: "secondary ml-auto",
                      class: { disabled: !_vm.formIsValid },
                      nativeOn: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.nextSlide($event)
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.$t("global.next")))]),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-chevron-right" }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("swiper-slide", [
            _c("p", { staticClass: "explaination-2 mt-0 mb-2" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("device.registrations.association_type.explanation")
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "type-selection-container" },
              [
                _c(
                  "Button2",
                  {
                    staticClass: "type-button",
                    class: { disabled: !_vm.canSendSms || _vm.isLoading },
                    attrs: { disabled: !_vm.canSendSms || _vm.isLoading },
                    nativeOn: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.selectType("sms")
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "association_type" }, [
                      _c("i", { staticClass: "fa fa-mobile fa-2x" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "type-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("device.registrations.association_type.sms")
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    !_vm.canSendSms
                      ? _c("span", { staticClass: "type-hint" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "device.registrations.association_type.requires_phone"
                                )
                              ) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "Button2",
                  {
                    staticClass: "type-button",
                    class: { disabled: !_vm.canSendEmail || _vm.isLoading },
                    attrs: { disabled: !_vm.canSendEmail || _vm.isLoading },
                    nativeOn: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.selectType("email")
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "association_type" }, [
                      _c("i", { staticClass: "fa fa-envelope fa-2x" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "type-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "device.registrations.association_type.email"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    !_vm.canSendEmail
                      ? _c("span", { staticClass: "type-hint" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "device.registrations.association_type.requires_email"
                                )
                              ) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "Button2",
                  {
                    staticClass: "type-button",
                    class: { disabled: !_vm.canShowQrCode || _vm.isLoading },
                    attrs: { disabled: !_vm.canShowQrCode || _vm.isLoading },
                    nativeOn: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.selectType("qrcode")
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "association_type" }, [
                      _c("i", { staticClass: "fa fa-qrcode fa-2x" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "type-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "device.registrations.association_type.qrcode"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex py-2" },
              [
                _c(
                  "Btn",
                  {
                    staticClass: "secondary prev-button",
                    attrs: { disabled: _vm.isLoading },
                    nativeOn: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.prevSlide($event)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-chevron-left" }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("global.prev")))]),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("swiper-slide", [
            _c("p", { staticClass: "explaination-2 mt-0 mb-2" }),
            _vm._v(" "),
            _c("div", { staticClass: "qrcode-container" }, [
              _c(
                "div",
                { class: "qrcode-inner" },
                [
                  _c("LoadingMini", { ref: "loadingQr" }),
                  _vm._v(" "),
                  _c("QRCode", {
                    class: { show: _vm.qrCodeUrl != "" },
                    attrs: {
                      text: _vm.qrCodeUrl,
                      size: 150,
                      color: "#212121",
                      "bg-color": "#FFFFFF",
                      "error-level": "Q",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "mt-0 mb-1" }, [
                _c("a", { attrs: { href: _vm.qrCodeUrl, target: "_blank" } }, [
                  _vm._v(_vm._s(_vm.qrCodeUrl)),
                ]),
              ]),
              _vm._v(" "),
              _vm.qrCodeUrl != ""
                ? _c(
                    "span",
                    { staticClass: "text-info-600" },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("device.registrations.expiresIn"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("Countdown", {
                        attrs: { date: _vm.qrCodeExpiration },
                        on: { expired: _vm.handleQrCodeExpired },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "explaination-3 my-2",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("device.registrations.assocExplaination3")
                ),
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "center" },
              [
                _c(
                  "Btn",
                  { staticClass: "primary reverse" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: _vm.deviceLink, tag: "div" } },
                      [
                        _c("i", { staticClass: "fa fa-mobile-phone" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("device.btns.goToShow"))),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }